module.exports = __webpack_public_path__ + "media/application/images/svgs/chevrons-left-6f82fe7fda22945f0def2e30ff6f72a0.svg";